import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { IUserLoginInfo } from '../models/i-user-login-info';
import { AllClientTypes } from '../models/client-type';
import { ITeamsContext } from '../models/i-teams.context';

@Injectable()
export abstract class IMicrosoftTeamsContextAccessor {
  public abstract get snapshot(): ITeamsContext;
  public abstract getContext$(): Observable<ITeamsContext>;
  public abstract getLoginHint$(): Observable<string>;
  public abstract getClientInfo$(): Observable<AllClientTypes>;
  public abstract getThemeInformation$(): Observable<string>;
  public abstract isStandAlone(): boolean;
  public abstract isStaticTab(): boolean;
  public abstract refreshContext(): void;
  public abstract trySpecifyUser(user: IUserLoginInfo): ITeamsContext;
}
